export const FETCH_MASTER_MANIFEST = "FETCH_MASTER_MANIFEST";
export const FETCH_MASTER_MANIFEST_PENDING = "FETCH_MASTER_MANIFEST_PENDING";
export const FETCH_MASTER_MANIFEST_REJECTED = "FETCH_MASTER_MANIFEST_REJECTED";
export const FETCH_MASTER_MANIFEST_FULFILLED = "FETCH_MASTER_MANIFEST_FULFILLED";
